<template>
  <div class="dialog" v-if="bShow">
    <div class="dialog-wrapper">
      <div class="head">
        <span class="title">{{title}}</span>
        <img class="close" @click="hide" src="./close.png" alt="close" width="20" height="20">
      </div>
      <slot name="content">
        当未设置slot时，显示此处内容
      </slot>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  export default{
    props: {
      title: {
        type: String
      }
    },
    data(){
      return {
        bShow: false,
      }
    },
    methods: {
      show() {
        this.bShow = true;
        let oBody = document.getElementsByTagName('body')[0];
        oBody.style.overflow='hidden';
      },
      hide(){
        this.bShow = false;
        let oBody = document.getElementsByTagName('body')[0];
        oBody.style.overflow='auto';
      }
    },
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .dialog
    position: fixed
    top: 0
    bottom: 0
    left: 0
    right: 0
    display: flex
    background: rgba(0, 0, 0, 0.3)
    z-index: 1000
    overflow: auto
    .dialog-wrapper
      margin:auto
      border-radius: 4px
      overflow: hidden
      background: #ffffff
      .head
        display: flex
        align-items: center
        justify-content: space-between
        height: 60px
        min-width: 450px
        background: #f2f2f2
        .title
          font-size: 20px
          color: #666666
          margin-left: 20px
        .close
          padding: 20px 10px
          cursor: pointer


</style>



// WEBPACK FOOTER //
// src/components/popdialog/PopDialog.vue